import React from 'react';
import { Box } from '@mui/material';

const Spinner: React.FC<{size?: number}> = ({ size = 48 }) => {
  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/just_logo.svg`}
        alt=""
        sx={{
          width: size,
          height: size,
          objectFit: 'contain',
          animation: 'logo-loading 1.4s ease-in-out infinite',
          '@keyframes logo-loading': {
            '0%, 100%': { transform: 'scale(0.9)', opacity: 0.7 },
            '50%': { transform: 'scale(1)', opacity: 1 },
          },
        }}
      />
    </Box>
  );
};

export default Spinner;
